import { useState } from "react";
import { MenuProps } from "antd";

// submenu keys of first level
const rootSubmenuKeys = ["sub1", "sub2", "sub4"];

export const useMenuOpenKeys = () => {
  const [openKeys, setOpenKeys] = useState(["sub1"]);

  const onOpenChange: MenuProps["onOpenChange"] = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey!) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  return {
    openKeys,
    onOpenChange,
  };
};
